module.exports = __webpack_public_path__ + "static/media/plus.13816a44.svg";